<template>
    <div>
        <ul class="at-floatimglist" v-if="minimizeChats.topChats.length">
            <li v-for="single in minimizeChats.topChats" :key="single.chatId">
                <a href="javascript:void(0);">
                    <template v-if="single.chatType == 0 || single.chatType == 1">
                        <img  :src="single.userAvatar" :alt="single.userName" @click.prevent="minimizeWidgetChatbox(single.chatId)" >
                        <span class="at-infotolltip">
                            <em>{{single.chatType == 0 ? single.postTitle +' - '+ single.userName : single.userName}}</em>
                        </span>
                    </template>
                    <template v-else-if="single.chatType == 2">
                        <img v-if="single.groupImage" :src="single.groupImage" :alt="single.groupTitle" @click.prevent="minimizeWidgetChatbox(single.chatId)">
                        <img v-else :src="single.userAvatar" :alt="single.userName" @click.prevent="minimizeWidgetChatbox(single.chatId)">
                        <span class="at-infotolltip">
                            <em>{{single.groupTitle +' - '+ single.userName}}</em>
                        </span>
                    </template>
                    <i class="guppy-x" @click.prevent="closeWidgetChatbox(single.chatId)"></i>
                    <span v-if="single.UnreadCount > 0" class="at-userstatus notify"></span>
                </a>
            </li>
       
            <li v-if="minimizeChats.bottomChats.length">
                <a href="javascript:void(0);" @click.prevent="toggleUsersMenue(!isOpenMenu)" id="at_moreitems">
                    <em> <i :class="isOpenMenu ? 'guppy-x' : 'guppy-more-horizontal'"></i> </em>
                </a>
                <div class="at-floatdropdownholder">
                    <ul class="at-floatdropdown">
                        <li v-for="single in minimizeChats.bottomChats" :key="single.chatId">
                            <a href="javascript:void(0);"  @click.prevent="minimizeWidgetChatbox(single.chatId)">
                            <template v-if="single.chatType == 0 || single.chatType == 1">
                                <img  :src="single.userAvatar" :alt="single.userName" >
                                <span>{{single.chatType == 0 ? single.postTitle : single.userName}}</span>
                            </template>
                            <template v-else-if="single.chatType == 2">
                                <img v-if="single.groupImage" :src="single.groupImage" :alt="single.groupTitle">
                                <img v-else :src="single.userAvatar" :alt="single.userName">
                                <span>{{single.groupTitle}}</span>
                            </template>
                            </a>
                        </li>
                    </ul>
                    <a href="javascript:void(0);" @click.prevent="closeAllChats()" >
                        <i class="guppy-x"></i>{{TRANS.close_all_conversation}}
                    </a>
                </div>
            </li>
        </ul>
        <guppywidget-chat-box :chatId="chat.chatId" v-for="chat in chats" :key="chat.chatId"/>
    </div>
</template>

<script>
import { GUPPYCHAT_SETTINGS } from "../../resources/constants";
import GuppywidgetChatBox from "./GuppywidgetChatBox.vue";
import GuppyChatManager from "../../resources/controller";
import jQuery from 'jquery';
export default { 
    name : "GuppyFloatingChatList",
    components :{
        GuppywidgetChatBox
    },
    data(){
        return {
            isOpenMenu    : false,
        }
    },
    computed:{
        minimizeChats(){
            let windowHeight = jQuery( window ).height();
            let showTopChats = 7; 
            if(windowHeight <= 800){
                showTopChats = 5;
            }else if(windowHeight < 770){
                showTopChats = 3;
            }
            let data    = { topChats : [] , bottomChats : [] }
            let chats   = this.$store.getters.minimizeChats; 
            data.topChats     = chats.slice(0,showTopChats);
            data.bottomChats  = chats.slice(showTopChats,chats.length);
            return data;
        },
        chats(){
            return this.$store.getters.widgetChats;
        },
    },
    methods:{
        toggleUsersMenue(toggle){
            this.isOpenMenu = toggle ;
            jQuery('.at-floatdropdownholder').slideToggle(200);
        },
        minimizeWidgetChatbox(chatId){
            this.$store.commit('minimizeWidgetChatbox', {chatId: chatId, isMinimize : false });
            this.isOpenMenu = false;
            jQuery('.at-floatdropdownholder').hide();
        },
        closeWidgetChatbox(chatId){
            this.$store.commit('closeWidgetChatbox', {chatId: chatId });
        },
        closeAllChats(){
            this.$store.commit('updateChatInfo', {});
        },
    },
    created(){
        if(GUPPYCHAT_SETTINGS.realTimeOption == 'pusher' && GUPPYCHAT_SETTINGS.pusherEnable){
        let settings = { 
            pusherKey     : GUPPYCHAT_SETTINGS.pusherKey,
            pusherCluster : GUPPYCHAT_SETTINGS.pusherCluster,
            restApiUrl    : window.wpguppy_scripts_vars.restapiurl,
            userId        : this.userId,
        };
        this.$store.dispatch('initializePusher', settings);
        }else if(GUPPYCHAT_SETTINGS.realTimeOption == 'socket' && GUPPYCHAT_SETTINGS.socketEnable){
        let settings = { 
            authToken     : window.wpguppy_scripts_vars.authToken,
            restApiUrl    : window.wpguppy_scripts_vars.restapiurl+'34',
            userId        : this.userId,
        };
        this.$store.dispatch('initializeSocket', settings);
        }
        if(this.userId > 0 && this.isSingle){
            this.axios.get('get-post-info?userId='+this.userId+'&postId='+this.postId).then( response => {
                if(response.data.type == 'success'){
                    let postInfo = response.data.postInfo;
                    if(postInfo !=''){
                        this.$store.commit('updateChatInfo', {data : postInfo, userClick : true});
                        if(postInfo.UnreadCount > 0){
                        let  userId   = this.userId;
                        let data = {
                            chatId      : postInfo.chatId,
                            chatType    : 0,
                            userId
                        }
                        GuppyChatManager.updateSeenMessagesCounter(data);
                        }
                    }
                }
            }).catch( errors =>{
                this.errors = errors;
                console.log(errors)
            });
        }
    }
}
</script>
<style>
    @import url("../resources/style.css");
    @import url("../resources/rtl.css");
</style>